import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const PageNumbers = styled.div`
    display:flex;
    align-items: center;
    gap:0.2rem;
    justify-content: center;
    position: absolute;
    bottom:20px;
    left:0;
    width:100%;
`;

export const Count = styled.div`
    position: absolute;    
    bottom:20px;
    left:20px;
    display:flex;
    align-items: start;
    gap:0.2rem;
    justify-content: start;
    color:#414141;
    font-size: 14px;
    font-weight: 500;
`;

export const PageSpan = styled.span<{ active?: boolean, disable?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width:26px;
    height:26px;
    text-decoration: ${props => props.active ? "underline" : "none"};
    border-radius: 50%;
    color:#414141;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    pointer-events: ${props => props.disable ? "none" : "unset"};
    opacity: ${props => props.disable ? "0.4" : "1"};
    transition: all 0.1s ease-in-out;

    svg{
        height:40%;

        path{
            fill:${props => props.active ? "#fff" : "#414141"};
        }
    }

    &:hover{
        background:#414141;
        color:#fff;
        
        svg{
            path{
                fill:#fff;
            }
        }
    }


`;